<template>
  <div class="tab-pane" role="tabpanel" aria-labelledby="home-tab">
    <div class="row mb-3 mt-3 align-items-center">
      <div class="col-md-5">
        <b-button-group class="flex-wrap">
          <b-button variant="outline-danger">
            <input
              type="checkbox"
              v-model="selectAll"
              @change="selectItemAll(selectAll)"
            />
          </b-button>
          <b-button
            variant="outline-danger"
            type="button"
            :disabled="recordIds.length == 0"
            @click="multiDelete"
            v-if="$role == 'super_admin' || $role =='QuranAdmin'"
          >
            <i class="fa fa-trash"></i>
            {{ $t("site.bulk_delete") }}
          </b-button>
          
        </b-button-group>
      </div>
      <div class="col-md-5">
        <div class="form-group">
          <input
            type="text"
            name="users"
            class="form-control"
            v-model="search"
            autocomplete="off"
            readonly
            onfocus="this.removeAttribute('readonly');"
            @input="(val) => searchChange(val)"
            :placeholder="$t(`site.search`)"
          />
        </div>
      </div>
      <div class="col-md-2">
        <div class="float-md-right pt-1">
          <span class="text-muted text-small mr-1 mb-2">
            {{ from }}:{{ to }}
          </span>

          <b-dropdown
            id="ddown2"
            right
            :text="`${perPage}`"
            variant="outline-warning"
            size="xs"
          >
            <b-dropdown-item
              v-for="(size, index) in [5, 10, 20, 50, 100]"
              :key="index"
              @click="changePageSize(size)"
              >{{ size }}</b-dropdown-item
            >
          </b-dropdown>
          <span class="text-muted mr-1 mb-2"> of {{ total }}</span>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 overflow-auto">
        <b-table :stacked="($mobile==1)" 
          ref="table"
          class="vuetable"
          sort-by="id"
          sort-desc.sync="false"
          :current-page="currentPage"
          :fields="bootstrapTable.fields"
          :items="dataProvider"
        >
          <template #cell(checkbox)="data">
            <label class="kt-checkbox kt-checkbox--single kt-checkbox--solid">
              <input
                type="checkbox"
                v-model="recordIds"
                :value="data.item.id"
                @change="selectItem(data)"
              />
              <span></span>
            </label>
          </template>
          <template #cell(active)="data">
            <b-form-checkbox
              v-model="data.item.active"
              class="custom-control-primary"
              name="check-button"
              value="1"
              @change="changeActive(data.item)"
              switch
            >
              <span class="switch-icon-left">
                <feather-icon icon="CheckIcon" />
              </span>
              <span class="switch-icon-right">
                <feather-icon icon="XIcon" />
              </span>
            </b-form-checkbox>
          </template>
          <template #cell(phone_number)="data">
            {{data.item.mobile  + ' ' + data.item.country.phone_code }}+
          </template>
          
     
          <template #cell(created_at)="data">
           {{ data.item.created_at.split("T")[0]}}
          </template>
          <template #cell(edit)="data">
            <button
              class="btn btn-icon btn-warning btn-sm"
              @click="editItem(data)"
            >
              <i class="fa fa-edit"></i>
            </button>
            <button
              class="btn btn-icon btn-danger btn-sm"
              @click="deleteItem(data)"
              v-if="$role == 'super_admin' || $role =='QuranAdmin'"
            >
              <i class="fa fa-trash"></i>
            </button>
          </template>
        </b-table>
        <hr />

        <b-pagination
          v-model="currentPage"
          align="right"
          class="dataTables_paginate paging_simple_numbers pagination-warning"
          :total-rows="totalRows"
          :per-page="perPage"
        >
          <template v-slot:next-text>
            <i class="fas fa-angle-left" />
          </template>
          <template v-slot:prev-text>
            <i class="fas fa-angle-right" />
          </template>
          <template v-slot:first-text>
            <i class="fas fa-step-forward" />
          </template>
          <template v-slot:last-text>
            <i class="fas fa-step-backward" />
          </template>
        </b-pagination>
        <!-- end of table -->
      </div>
      <!-- end of col -->
    </div>
    <!-- end of row -->
  </div>
</template>

<script>
import controller from "../../../../Controllers/UsersController";
import Auth from "@/Apis/Auth";
import Swal from "sweetalert2";
const appLoading = document.getElementById("loading-bg");

export default {
  name: "UsersDataTable",
  props: ["items", "editItem"],
  data() {
    return {
      bootstrapTable: {
        selected: [],
        selectMode: "multi",
        fields: this.getTableFields(),
      },
      data: {},
      selectAll: false,
      
      currentPage: 1,
      select: [],
      page: 1,
      perPage: 5,
      search: "",
      from: 0,
      total: 0,
      totalRows: 0,
      to: 0,
      lastPage: 0,
      load: false,
      apiParams: {},
      params: {},
      recordIds: [],
      user: {},
      eduPrograms: [],
    };
  },
  created() {
    
  },
  methods: {
    getTableFields() {
      // If user role is QuranAdmin, show only name fields
      if (this.$role === 'QuranAdmin') {
        return [
          { key: "checkbox", label: "", sortable: false },
          {
            key: "first_name",
            label: this.$i18n.t("students.first_name"),
            sortable: true,
          },
          {
            key: "last_name",
            label: this.$i18n.t("students.last_name"),
            sortable: true,
          },
          {
          key: "country.name",
          label: this.$i18n.t("countries.country"),
          sortable: false,
        },
          {
            key: "phone_number",
            label: 'رقم الهاتف',
            sortable: true,
          },
          { key: "edit", label: this.$i18n.t("site.action"), sortable: false },
        ];
      }
      
      // For other roles, show all fields
      return [
        { key: "checkbox", label: "", sortable: false },
        {
          key: "code",
          label: this.$i18n.t("students.academic_number"),
          sortable: true,
        },
        {
          key: "first_name",
          label: this.$i18n.t("students.first_name"),
          sortable: true,
        },
        {
          key: "last_name",
          label: this.$i18n.t("students.last_name"),
          sortable: true,
        },
        {
          key: "email",
          label: this.$i18n.t("users.email"),
          sortable: true,
        },
        {
          key: "country.name",
          label: this.$i18n.t("countries.country"),
          sortable: false,
        },
        {
          key: "birth_date",
          label: this.$i18n.t('students.birth_date'),
          sortable: false,
        },
        {
          key: "created_at",
          label: this.$i18n.t("site.created_at"),
          sortable: true,
        },
        {
          key: "active",
          label: this.$i18n.t("site.active"),
          sortable: true,
        },
        { key: "edit", label: this.$i18n.t("site.action"), sortable: false },
      ];
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    async dataProvider(ctx) {
      this.load = true;
      this.params = ctx;
      const data = await new controller().GetAll(this.apiParamsConverter());
      this.currentPage = data.current_page;
      this.perPage = data.per_page;
      this.totalRows = data.total;
      this.from = data.from;
      this.to = data.to;
      this.total = data.total;
      this.data = data.data;
      this.load = false;
      return data.data;
    },
    apiParamsConverter() {
      let apiParams = { per_page: this.perPage };
      if (this.params.currentPage >= 1) {
        apiParams.page = this.params.currentPage;
      }
      if (this.params.sortBy && this.params.sortBy.length > 0) {
        apiParams.sort = `${this.params.sortBy}|${
          this.params.sortDesc ? "desc" : "asc"
        }`;
      }
      if (this.params.filter && this.params.filter.length > 0) {
        // Optional
      }
      if (this.search !== "") {
        apiParams.search = this.search;
      }

      apiParams.with = ["country"];
      console.log(this.type);
      apiParams.type =  "student";
      apiParams.filter = 'metaData|"{quran:1}"';
       return apiParams;
    },
    changePageSize(perPage) {
      this.page = 1;
      this.perPage = perPage;
      this.dataProvider(this.params);
      this.$refs.table.refresh();
    },
    searchChange() {
      if (this.search.length == 0) {
        this.dataProvider(this.params);
        this.$refs.table.refresh();
      }
      if (this.search.length < 2) return;
      this.page = 1;
      this.dataProvider(this.params);
      this.$refs.table.refresh();
    },
    selectItemAll(select) {
      this.recordIds = [];
      if (select) {
        console.log(this.data);
        this.data.forEach((element) => {
          this.recordIds.push(element.id);
        });
      }
    },
    changeActive(data) {
      new controller().ToggleActivation(data.id);
    },
    deleteItem(data) {
      new controller().Delete(data.item.id, [], this.$refs.table);
    },
    multiDelete() {
      new controller().Delete(0, this.recordIds, this.$refs.table);
    },
    async impersonate(data) {
      const res = await Auth.impersonate(data.item);
      console.log(res);
      if (res) {
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: this.$i18n.t("site.successfully"),
          showConfirmButton: false,
          timer: 1000,
        }).then(() => {
          window.location.href = "/dashboard";
        });
      } else {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Oops...",
          text: res.message,
          showConfirmButton: false,
          timer: 1000,
        });
      }
    },
  },
  watch: {
    // $route(to, from) {
    //   if (this.$route.name == "Users") {
    //     this.type = "admin";
    //   } else if (this.$route.name == "Teachers") {
    //     this.type = "teacher";
    //   } else if (this.$route.name == "Students") {
    //     this.type = "student";
    //   }
    //   this.$refs.table.refresh();
    // },
  },
};
</script>

